import monetary from '../../../services/api/calculators/monetary';
import dates from '../../../services/api/calculators/dates';
import {validDate} from 'components/form/validator/validations';
import Moment from 'moment';
import _ from 'lodash';
import moment from "moment/moment";

const mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    ADD_INCOME_PERIOD: 'ADD_INCOME_PERIOD',
    UPDATE_INCOME_PERIOD: 'UPDATE_INCOME_PERIOD',
    UPDATE_INCOME_PERIOD_VALUE: 'UPDATE_INCOME_PERIOD_VALUE',
    DELETE_INCOME_PERIOD: 'DELETE_INCOME_PERIOD',
    RESET: 'RESET',
    LOADING: 'LOADING'
};

const allPeriodsValid = (state) => {
    let periods = state.periods.map(period => {
        if (period.employmentType !== 'absence') {
            return (
                period.startOfPeriod !== ""
                && period.startOfPeriod !== null
                && period.endOfPeriod !== ""
                && period.endOfPeriod !== null
                && (period.employmentIncome !== null || period.employmentIncome !== "")
                && period.employmentType !== null
            )
        }
        return (
            period.startOfPeriod !== ""
            && period.startOfPeriod !== null
            && period.endOfPeriod !== ""
            && period.endOfPeriod !== null
            && period.employmentType !== null
        )
    });

    return periods.reduce((valid, value) => valid ? (value === true) : false, true);
};

const getPeriodDate = (state) => {
    let sorted = _.sortBy(state.periods, [function(period) {
        return moment(period.startOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');
    }]);

    return sorted[0].startOfPeriod;
};

const periodNetLoss = (state, period) => {
    let duration = moment(period.endOfPeriod, 'DD/MM/YYYY')
        .diff(moment(period.startOfPeriod, 'DD/MM/YYYY'), 'years', true);
    let preLossIncome = state.totalNetIncome;
    let lossIncome = period.totalNetIncome;

    return (parseFloat(duration.toFixed(2)) * preLossIncome)
        - (parseFloat(duration.toFixed(2)) * lossIncome);
};

export function defaultPeriodTemplate() {
    return {
        startOfPeriod: null,
        endOfPeriod: null,
        employmentType: null,
        employmentIncome: 0,
        employmentNetGross: 'gross',
    }
};

// Initial State
const state = {
    dateOfBirth: null,
    gender: null,
    retirementDate: null,
    employmentType: 'employed',
    employmentIncome: 0,
    employmentNetGross: 'gross',
    periods: [],
    totalNetIncome: 0,
    totalGrossIncome: 0,
    totalNetLoss: 0,
    loading: false
};

// Getters
const getters = {
    findValue: state => key => state[key],
    periods: state => state.periods,
    periodsValid: state => allPeriodsValid(state)
};

// Actions
const actions = {
    updateValue({ state, commit, dispatch }, {key, value}) {
        commit(mutationTypes.UPDATE_VALUE, {key, value});

        if (key === 'dateOfBirth' || key === 'gender') {
            dispatch('statePensionDate');
        }

        dispatch('calculatePeriodLoss')
    },
    statePensionDate({ state, commit }) {
        if (!state.dateOfBirth || !state.gender) {
            return;
        }

        let person = {
            dateOfBirth: state.dateOfBirth,
            gender: state.gender,
        };

        return dates.statePensionAge(person)
            .then((data) => {
                commit(mutationTypes.UPDATE_VALUE, {
                    key: 'retirementDate',
                    value: data.statePension.retirementDate
                });
            });
    },
    addPeriod({ commit }) {
        commit(mutationTypes.ADD_INCOME_PERIOD);
    },
    updatePeriod({ commit, state }, payload) {
        commit(mutationTypes.UPDATE_INCOME_PERIOD, payload);
    },
    deletePeriod({ commit }, index) {
        commit(mutationTypes.DELETE_INCOME_PERIOD, index);
    },
    calculatePeriodLoss({ state, dispatch }, index) {
        dispatch('calculateIncome');
        dispatch('calculateLossOfEarnings', {period: state.periods[index], index});
    },
    calculateIncome: _.debounce(({ state, commit, dispatch }) => {
        if (allPeriodsValid(state)) {
            let endOfPeriod = getPeriodDate(state);

            let period = {
                employmentType: state.employmentType,
                employmentIncome: state.employmentIncome,
                employmentNetGross: state.employmentNetGross,
                startOfPeriod: moment(endOfPeriod, 'DD/MM/YYYY').subtract(1, "year").format('DD/MM/YYYY'),
                endOfPeriod: endOfPeriod
            };

            let person = {
                income: {
                    retirementDate: state.retirementDate
                }
            };

            commit(mutationTypes.LOADING, true);

            monetary.income(period, person)
                .then((data) => {
                        commit(mutationTypes.LOADING, false);
                        commit(mutationTypes.UPDATE_VALUE, {key: 'totalNetIncome', value: data.totalNetIncome});
                        commit(mutationTypes.UPDATE_VALUE, {key: 'totalGrossIncome', value: data.totalGrossIncome});
                        dispatch('calculateTotalNetLoss');
                    })
        }
    }, 1000),
    calculateLossOfEarnings: _.debounce(({ state, commit, dispatch }, {period, index}) => {
        if (allPeriodsValid(state)) {
            let person = {
                income: {
                    retirementDate: state.retirementDate
                }
            };

            commit(mutationTypes.LOADING, true);

            monetary.income(period, person)
                .then((data) => {
                    commit(mutationTypes.LOADING, false);
                    commit(mutationTypes.UPDATE_INCOME_PERIOD_VALUE, {
                        index,
                        key: 'totalNetIncome',
                        value: data.totalNetIncome
                    });
                    commit(mutationTypes.UPDATE_INCOME_PERIOD_VALUE, {
                        index,
                        key: 'totalGrossIncome',
                        value: data.totalGrossIncome
                    });
                    dispatch('calculateTotalNetLoss');
                })
        }
    }, 1000),
    calculateTotalNetLoss({ state, commit }) {
        let periods = state.periods.map((period) => {
            return parseFloat(periodNetLoss(state, period).toFixed(2));
        });

        let total =  periods.reduce((total, carry) => total + carry ,0) || 0;

        commit(mutationTypes.UPDATE_VALUE, {key: 'totalNetLoss', value: total});
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_VALUE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.ADD_INCOME_PERIOD](state) {
        state.periods.push(defaultPeriodTemplate());
    },
    [mutationTypes.DELETE_INCOME_PERIOD](state, index) {
        state.periods.splice(index, 1);
    },
    [mutationTypes.UPDATE_INCOME_PERIOD_VALUE](state, payload) {
        state.periods[payload.index][payload.key] = payload.value;
    },
    [mutationTypes.UPDATE_INCOME_PERIOD](state, payload) {
        state.periods[payload.index] = payload.period;
    },
    [mutationTypes.LOADING](state, boolean) {
        state.loading = boolean
    },
    [mutationTypes.RESET](state) {
        state.dateOfBirth = null;
        state.gender = null;
        state.retirementDate = null;
        state.employmentType = 'employed';
        state.employmentIncome = 0;
        state.employmentIncomeNetGross = 'gross';
        state.periods = [];
        state.periods.push(defaultPeriodTemplate());
        state.totalNetIncome = 0;
        state.totalGrossIncome = 0;
        state.totalNetLoss = 0;
        state.loading = false;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/lossOfEarnings.js